// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"136d9d59","510":"1aff0e70"}[chunkId] + ".chunk.css";
};